"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    titleInfo: [Object],
    backPath: {
      type: String,
      default: "1"
    }
  },
  data: function data() {
    return {};
  }
};